// extracted by mini-css-extract-plugin
module.exports = {"layout":"BaseLayout--layout--CmxuE","headerIco":"BaseLayout--header-ico--wcIbC","copylight":"BaseLayout--copylight--1OPBr"};